// extracted by mini-css-extract-plugin
export var dateLabel = "_4g-0";
export var dateLabelError = "_4g-1";
export var fullWidth = "_4g-2";
export var smaller = "_4g-3";